<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-accessibility|@@accessibility">Accessibilité</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 report-form">
      <div class="container">
        <div class="row">
          <div class="col-12 ">
            <span class="column-title" i18n="parameters-accessibility|@@user">Utilisateur</span>

            <div *ngIf="settings" class="table-option-toggle">
              <div class="conatainer">
                <div class="row m-0 center-toggle">
                  <div class="col-9">
                    <span class="column-title" i18n="table-options-toggle|@@option">Option</span>
                  </div>
                  <div class="col-3">
                    <span class="column-title" i18n="table-options-toggle|@@active">Activé</span>
                  </div>
                </div>
                <div class="row m-0">
                  <div class="col-9 center-toggle">
                    <span i18n="parameters-accessibility|@@AlwaysShowIcons">Laisser afficher en permanence les icones
                      disponibles au survol dans la liste les Tcheks</span>
                  </div>
                  <div class="col-3">
                    <div class="parameters-toggle">
                      <app-generic-toggle  (sendData)="settings.accessibility.showIcons = $event; sendData()" [value]="settings.accessibility.showIcons" ></app-generic-toggle>
                    </div>
                  </div>
                </div>

                <div class="row m-0" *ngIf="isSuperAdmin">
                  <div class="col-9 center-toggle">
                    <span i18n="parameters-accessibility|@@AlwaysShowNumberPlate" >Afficher la plaque d'immat (DEBUG)</span>
                  </div>
                  <div class="col-3">
                    <div class="parameters-toggle " >
                      <app-generic-toggle (sendData)="settings.accessibility.showImmatPicture = $event; sendData()" [value]="settings.accessibility.showImmatPicture" ></app-generic-toggle>
                    </div>
                  </div>
                </div>

                <!-- fast track -->
                <div class="row m-0">
                  <div class="col-9 center-toggle">
                    <span i18n="parameters-accessibility|@@UseFastTrack">Utiliser la page FastTrack pour le traitement
                      des dommages.</span>
                  </div>
                  <div class="col-3">
                    <div class="parameters-toggle ">
                      <app-generic-toggle (sendData)="settings.accessibility.useFastTrack = $event; sendData()" [value]="settings.accessibility.useFastTrack" ></app-generic-toggle>
                    </div>
                  </div>
                </div>
                <div class="row m-0" *ngIf="settings.accessibility.useFastTrack">
                  <div class="col-9 center-toggle">
                    <span i18n="parameters-accessibility|@@fastTrackZoom">FastTrack : Zoom sur les dommages</span>
                  </div>
                  <div class="col-3">
                    <div class="parameters-toggle ">
                      <app-generic-toggle (sendData)="settings.accessibility.fastTrackZoom = $event; sendData()" [value]="settings.accessibility.fastTrackZoom" ></app-generic-toggle>
                    </div>
                  </div>
                </div>
                <div class="row m-0" *ngIf="settings.accessibility.useFastTrack">
                  <div class="col-9 center-toggle">
                    <span i18n="parameters-accessibility|@@fastTrackComp">FastTrack : Bouton Comparaison Rapide</span>
                  </div>
                  <div class="col-3">
                    <div class="parameters-toggle ">
                      <app-generic-toggle (sendData)="settings.accessibility.fastTrackComp = $event; sendData()" [value]="settings.accessibility.fastTrackComp" ></app-generic-toggle>
                    </div>
                  </div>
                </div>
                <div class="row m-0" *ngIf="settings.accessibility.useFastTrack">
                  <div class="col-8 center-toggle">
                    <span i18n="parameters-accessibility|@@fastTrackControlDamages">FastTrack : Contrôler les dommages
                      de niveau
                      :</span>
                  </div>
                  <div class="col-4">
                    <div class="row p-0">
                      <div class="col-4 mt-auto mb-auto">
                        High
                      </div>
                      <div class="col-8 mt-auto mb-auto">
                        <div class="parameters-toggle ">
                          <app-generic-toggle (sendData)="settings.accessibility.fastTrackL3 = $event; sendData()" [value]="settings.accessibility.fastTrackL3" ></app-generic-toggle>
                        </div>
                      </div>
                    </div>

                    <div class="row p-0">
                      <div class="col-4 mt-auto mb-auto">
                        Medium
                      </div>
                      <div class="col-8 mt-auto mb-auto">
                        <div class="parameters-toggle ">
                          <app-generic-toggle (sendData)="settings.accessibility.fastTrackL2 = $event; sendData()" [value]="settings.accessibility.fastTrackL2" ></app-generic-toggle>
                        </div>
                      </div>
                    </div>

                    <div class="row p-0">
                      <div class="col-4 mt-auto mb-auto">
                        Low
                      </div>
                      <div class="col-8 mt-auto mb-auto">
                        <div class="parameters-toggle ">
                          <app-generic-toggle (sendData)="settings.accessibility.fastTrackL1 = $event; sendData()" [value]="settings.accessibility.fastTrackL1" ></app-generic-toggle>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-accessibility/parameters-accessibility.component.html